/* eslint-disable */
import { ORDER_QUANTITY_METER_CUBIC } from '../../../Constants/Order/Order.constants';

/**
 * Converts the unit into its display unit
 * @param {string} unit The unit
 * @returns {string} The display unit
 */
const toDisplayUnit = (unit = ``) => {
  return unit === ORDER_QUANTITY_METER_CUBIC ? `m³` : unit;
};

export default toDisplayUnit;
